module.exports = __webpack_public_path__ + "img/3_2.8b6f0677.png";